/* eslint-disable import/prefer-default-export */
import { camelCaseObject, getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import { convertObjectToSnakeCase } from '../../utils';
import { normalizeCertificateDisplayBehavior } from '../constants';

const getApiBaseUrl = () => getConfig().STUDIO_BASE_URL;
export const getCourseDetailsApiUrl = (courseId) => `${getApiBaseUrl()}/api/contentstore/v1/course_details/${courseId}`;
export const getCourseSettingsApiUrl = (courseId) => `${getApiBaseUrl()}/api/contentstore/v1/course_settings/${courseId}`;
export const getUploadAssetsUrl = (courseId) => `${getApiBaseUrl()}/assets/${courseId}/`;

const normalizeCourseDetails = (details) => {
  const normalizedDetails = camelCaseObject(details);
  if (typeof normalizedDetails !== 'object' || normalizedDetails === null) {
    return normalizedDetails;
  }

  if (!Object.prototype.hasOwnProperty.call(normalizedDetails, 'certificatesDisplayBehavior')) {
    return normalizedDetails;
  }

  return {
    ...normalizedDetails,
    certificatesDisplayBehavior: normalizeCertificateDisplayBehavior(
      normalizedDetails.certificatesDisplayBehavior,
    ),
  };
};

const normalizeCourseDetailsForPayload = (details) => {
  if (typeof details !== 'object' || details === null) {
    return details;
  }

  if (!Object.prototype.hasOwnProperty.call(details, 'certificatesDisplayBehavior')) {
    return details;
  }

  return {
    ...details,
    certificatesDisplayBehavior: normalizeCertificateDisplayBehavior(
      details.certificatesDisplayBehavior,
    ),
  };
};

/**
 * Get course details.
 * @param {string} courseId
 * @returns {Promise<Object>}
 */
export async function getCourseDetails(courseId) {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getCourseDetailsApiUrl(courseId)}`,
  );
  return normalizeCourseDetails(data);
}

/**
 * Update course details.
 * @param {string} courseId
 * @param {object} details
 * @returns {Promise<Object>}
 */
export async function updateCourseDetails(courseId, details) {
  const { data } = await getAuthenticatedHttpClient().put(
    `${getCourseDetailsApiUrl(courseId)}`,
    convertObjectToSnakeCase(normalizeCourseDetailsForPayload(details), true),
  );
  return normalizeCourseDetails(data);
}

/**
 * Get course settings.
 * @param {string} courseId
 * @returns {Promise<Object>}
 */
export async function getCourseSettings(courseId) {
  const { data } = await getAuthenticatedHttpClient().get(
    `${getCourseSettingsApiUrl(courseId)}`,
  );
  return camelCaseObject(data);
}
